import Logo from "../src/img/Logo.png";

const domain = "https://api.azucarai.com";

// const domain = "http://localhost:8000";
const logo = Logo;

const globalVariable = {
  domain,
  logo,
};
export default globalVariable;
